import React from "react";
import { useLocation } from "react-router";
// import Header from "../../header/Header";
import Posts from "../../posts/Posts";
import Sidebar from "../../Sidebar/Sidebar";
import "./homepage.css";

export default function Homepage() {
  const location = useLocation();
  console.log(location);
  return (
    <>
      {/* <Header /> */}
      <div className="home">
        <Posts />
        <Sidebar />
      </div>
    </>
  );
}
